import { MdsIconKind } from "@/design-system/components/icon/types";
import { ButtonProps } from "react-aria-components";

export enum MDSCardSlotName {
  RightAddon = "rightAddon",
  Content = "content",
}

export interface IMDSCardProps extends ButtonProps {
  /**
   * Icon kind to display
   */
  mdsIcon?: MdsIconKind | (() => React.ReactNode);

  /**
   * Card title
   */
  title?: string;

  /**
   * Card subtitle (rendered aligned below the title)
   */
  subtitle?: string;

  /**
   * Card description text
   */
  description?: string;

  className?: string;

  children: React.ReactNode;
}
